const __WEBPACK_NAMESPACE_OBJECT__ = window["*/plaudit-query-loop/viewScript"];